import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostCreateBonuses = (params, setShowModal) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CREATE_BONUSES
            });

            if (data.status === 'success') {
                const id = data.data.id;
                window.location.replace(window.location.origin + `/bonuses/settings/${params.label}/${id}`);
            }
        } catch (error) {
            //todo доделать catch 
            setShowModal(true)
            getCatchError(error)
        }
    }
}


export {
    setPostCreateBonuses as SetPostCreateBonuses
}